import React, { lazy, useEffect } from 'react';
import SectionSkeleton from './sectionskeleton';
import LazySection from 'components/lazySection';
import { useLocation } from 'react-router-dom';
const SustainabilityApproach = lazy(() => import("components/Sustainbility/sustainbilityApproch"));
const SustainabilityAward = lazy(() => import("components/Sustainbility/sustainbilityAward"));
const SustainabilityBanner = lazy(() => import("components/Sustainbility/sustainbilityBanner"));
const SustainabilityDecarbonation = lazy(() => import("components/Sustainbility/sustainbilityDecarbonation"));
const SustainabilityImpactStart = lazy(() => import("components/Sustainbility/sustainbilityImpactStart"));
const SustainabilityReport = lazy(() => import("components/Sustainbility/sustainbilityReport"));
const SustainabilitySocialImpact = lazy(() => import("components/Sustainbility/sustainbilitySocialImpact"));
const SustainabilityAbout = lazy(() => import("components/Sustainbility/sustainbitilityAbout"));


const SustainabilityWith: React.FC = () => {
  const location = useLocation();
  const hash = location.hash;
   useEffect(() => {
    if (!location.hash) return;

    let attempts = 0;
    const maxAttempts = 20;

    const scrollToHash = () => {
      const element = document.querySelector(location.hash);

      if (element) {
        const y =
          element.getBoundingClientRect().top +
          window.pageYOffset -
          120;

        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(scrollToHash, 150); // retry
      }
    };

    // small delay to allow render
    setTimeout(scrollToHash, 100);

  }, [location.pathname, location.hash]);
return (

    // <>
    //   {/* Immediate load (important for LCP) */}
    //   <SustainabilityBanner />
     
    //     <SustainabilityAbout />
    //         <SustainabilityApproach />
       
    //         <SustainabilityImpactStart />
       
    //         <SustainabilityAward />
       
    //         <SustainabilitySocialImpact />
    //         <SustainabilityDecarbonation />
    //         <SustainabilityReport />
      
    // </>
     <>
        <SustainabilityBanner /> 
          {hash  ? (
            <>
            <SustainabilityAbout />
            <SustainabilityApproach />
       
            <SustainabilityImpactStart />
       
            <SustainabilityAward />
       
            <SustainabilitySocialImpact />
            <SustainabilityDecarbonation />
            </>
              ) : (
                <>
                    <LazySection fallback={<SectionSkeleton height={300} />}>
                      <SustainabilityAbout />
                    </LazySection>
                    <LazySection fallback={<SectionSkeleton height={350} />}>
                      <SustainabilityApproach />
                    </LazySection>
                      <LazySection fallback={<SectionSkeleton height={350} />}>
                        <SustainabilityImpactStart />
                      </LazySection>
                        <LazySection fallback={<SectionSkeleton height={350} />}>
                        <SustainabilityAward />
                      </LazySection>
                        <LazySection fallback={<SectionSkeleton height={350} />}>
                        <SustainabilitySocialImpact />
                      </LazySection>
                         <LazySection fallback={<SectionSkeleton height={350} />}>
                        <SustainabilityDecarbonation />
                      </LazySection>
                     
              </>
            )}
              <LazySection fallback={<SectionSkeleton height={350} />}>
                        <SustainabilityReport />
                      </LazySection> 
    </> 
    );
};

export default SustainabilityWith;